import { CAT_WEBSITES } from 'App/utils/Collections';

export default {
  category: CAT_WEBSITES,
  filters: [],
  searchBarProp: 'name',
};
